import React, { useState, useMemo, useCallback, useEffect, useContext } from 'react';
import HeaderYear from './HeaderYear/HeaderYear';
import UserContext from '../../../../../../../../common/utils/getContext';
import moment from 'moment';
import css from './CustomHeader.module.scss';
import classnames from 'classnames';
import { useMonths } from '../../../../../../../../common/utils/datas';

const CustomHeader = ({
    execludeYear,
    changeYear,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
    date,
    lastYear
}) => {
    const [activeYear, setAvtiveYear] = useState(new Date(date).getFullYear());
    const [activeMonth, setAvtiveMonth] = useState(new Date(date).getMonth());
    const [disabledPrev, setDisabledPrev] = useState(false);
    const [disabledNext, setDisabledNext] = useState(false);
    const { time } = useContext(UserContext);

    const years = useMemo(
        () => Array.from({ length: 100 }, (_, i) => Number(moment(moment(lastYear).isValid() ? lastYear : time.date).year()) - i),
        [time, lastYear]
    );
    const { months } = useMonths();
    const yearSetter = useCallback(
        (value) => {
            changeYear(value);
            setAvtiveYear(value);
        },
        [changeYear, setAvtiveYear]
    );
    useEffect(() => {
        const year = new Date(date).getFullYear();
        const month = new Date(date).getMonth();
        setAvtiveYear(year);
        setAvtiveMonth(month);
        if (year === years[0] && month === 0) {
            if (!disabledPrev) setDisabledPrev(true);
        } else if (disabledPrev) setDisabledPrev(false);
        if (year === years[years.length - 1] && month === 11) {
            if (!disabledNext) setDisabledNext(true);
        } else if (disabledNext) setDisabledNext(false);
    }, [date, disabledNext, disabledPrev, years]);

    return (
        <div className={classnames(css.dpHeader, 'dpHeader')}>
            <button
                type='button'
                onClick={decreaseMonth}
                disabled={prevMonthButtonDisabled || disabledPrev}
                className='dpHeader__arrow'
            />
            <div className={css.dpHeader_month_year}>
                <p className={css.dpHeader__date}>{months[activeMonth]}</p>
                {!execludeYear ? (
                    <HeaderYear years={years} changeYear={changeYear} activeYear={activeYear} yearSetter={yearSetter} />
                ) : null}
            </div>
            {/* <div className={css.dpHeader__control}> */}
            <button
                type='button'
                onClick={increaseMonth}
                disabled={nextMonthButtonDisabled || disabledNext}
                className='dpHeader__arrow dpHeader__arrow_right'
            />
            {/* </div> */}
        </div>
    );
};
export default CustomHeader;
